import classNames from "classnames";

import { getAssetURL } from "../../utils/assets";

export default function Error403() {
  return (
    <div className="w-screen h-screen">
      <main
        className={classNames(
          "h-full w-full px-6 py-16 mx-auto max-w-7xl sm:pb-24 lg:px-8 h-full",
        )}
      >
        <img
          className="w-auto h-16 mx-auto sm:h-12"
          src={getAssetURL("branding/mark_color.png")}
          alt="Layer AI"
        />
        <div className="max-w-2xl mx-auto mt-20 text-center sm:mt-24">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-layer-50 sm:text-5xl">
            Unauthorized
          </h1>
          <p className="mt-4 text-base leading-7 text-layer-300 sm:mt-6 sm:text-lg sm:leading-8">
            You do not have access to this workspace. Please use the sidebar to
            go back to a known page, or reach out to the workspace admins to
            request access.
          </p>
        </div>
      </main>
    </div>
  );
}
